import React, { useEffect, useMemo, useState } from 'react';
import axios from 'axios';
import { useLocation } from 'react-router-dom';
import CMSRenderer from '../components/cms/CMSRenderer';

export default function CMSPageView() {
  const location = useLocation();
  const slug = useMemo(() => {
    const p = location?.pathname || '';
    const cleaned = p.replace(/^\/cms\/?/, '').replace(/^\/+|\/+$/g, '');
    return cleaned;
  }, [location]);
  const [page, setPage] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    (async () => {
      try {
        setLoading(true);
        setError('');
        const { data } = await axios.get('/api/public/cms/by-slug', { params: { slug } });
        if (!data?.page) throw new Error('not_found');
        setPage(data.page);
      } catch (e) {
        setError(e?.response?.data?.error || 'not_found');
      } finally {
        setLoading(false);
      }
    })();
  }, [slug]);

  const blocks = useMemo(() => (Array.isArray(page?.content) ? page.content : []), [page]);

  if (loading) {
    return <div style={{ padding: 24, color: '#666' }}>載入中...</div>;
  }

  if (error || !page) {
    return <div style={{ padding: 24, color: '#b3261e' }}>頁面不存在或尚未發佈。</div>;
  }

  return <CMSRenderer blocks={blocks} pageTitle={page.title} pageDesc={page.seo_desc} />;
}
